// components/shared/FilterChips.jsx
import React from 'react';

const DEFAULT_COLOR = '#22d3ee';

const FilterChips = ({
  chipGroups = null,
  chips = [],
  chipQuery,
  setChipQuery,
  chipsOpen,
  setChipsOpen,
}) => {
  const terms = chipQuery.toLowerCase().split(',').map(t => t.trim()).filter(Boolean);
  const activeCount = terms.length;
  const groups = chipGroups ?? [{ color: DEFAULT_COLOR, values: chips }];

  const toggleChip = (f) => {
    const isActive = terms.includes(f.toLowerCase());
    if (isActive) {
      setChipQuery(terms.filter(t => t !== f.toLowerCase()).join(','));
    } else {
      setChipQuery(
        terms.length > 0
          ? [...terms, f.toLowerCase()].join(',')
          : f.toLowerCase()
      );
    }
  };

  const renderChip = (f, color) => {
    const active = terms.includes(f.toLowerCase());
    return (
      <span
        key={f}
        className={`fr-chip ${active ? 'fr-chip-active' : ''}`}
        onClick={() => toggleChip(f)}
        style={{
          background: active ? `${color}22` : undefined,
          color: active ? color : undefined,
          borderColor: active ? `${color}80` : `${color}90`,
          boxShadow: active ? `0 0 8px ${color}30` : undefined,
        }}
      >
        {f}
      </span>
    );
  };

  const renderChipList = () => (
    <div className="fr-filter-chips">
      {groups.map((group, gi) => (
        <React.Fragment key={gi}>
          {group.values.map(f => renderChip(f, group.color))}
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <>
      <div className="fr-chips-mobile">
        {chipsOpen ? (
          <div className="fr-chips-mobile-open">
            {renderChipList()}
            <button
              className="fr-chips-toggle"
              onClick={() => setChipsOpen(false)}
            >
              <span className="fr-chips-toggle-text">
                Close Filters {activeCount > 0 && (
                  <span className="fr-chips-badge">{activeCount}</span>
                )}
              </span>
              <span className="fr-chips-toggle-hint">
                Tap to close filters
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(148, 163, 184, 0.5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 15 12 9 18 15" />
                </svg>
              </span>
            </button>
          </div>
        ) : (
          <button
            className="fr-chips-toggle"
            onClick={() => setChipsOpen(true)}
          >
            <span className="fr-chips-toggle-text">
              Filters {activeCount > 0 && (
                <span className="fr-chips-badge">{activeCount}</span>
              )}
            </span>
            <span className="fr-chips-toggle-hint">
              Tap to open filters
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(148, 163, 184, 0.5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
          </button>
        )}
      </div>
      <div className="fr-chips-desktop">
        {renderChipList()}
      </div>
    </>
  );
};

export default FilterChips;